__turbopack_context__.v({
  "active": "ImproveAIButton-module__LnLSEq__active",
  "button": "ImproveAIButton-module__LnLSEq__button",
  "gradientSlide": "ImproveAIButton-module__LnLSEq__gradientSlide",
});
